<template><!-- svgo-optimised -->
<svg class="icon icon__check" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m16.8 8.4-7.16 7.2-2.44-2.454" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" fill="none"/></svg>
</template>